// Rajpurohit Perfumes — house catalogue
// The nine extraits below are the real range. Names, codes and note lines are
// transcribed from the printed labels; edit prices here and every surface updates.

export const bottleImg = (slug) => `/bottles/${slug}.webp`;

/** Transparent bottle cutouts from public/product-without-bg */
export const nobgBottleImg = (slug) => `/product-without-bg/${slug}-Photoroom.webp`;

export const HERO_FEATURED_SLUGS = ['ombre-nomade', 'rose-and-oud', 'aventus', 'dark-secret'];

// Lead image for cards and the product page: the lifestyle shot when one exists,
// otherwise the studio plate.
export const heroImg = (p) => (p.shots && p.shots[0]) || bottleImg(p.slug);

export const announcements = [
  "Flat 10% off on all prepaid orders · Founder's Edit sale",
];

export const navLinks = [
  { label: 'Shop All', href: '#shop' },
  { label: 'For Him', href: '#him' },
  { label: 'For Her', href: '#her' },
  { label: 'Unisex', href: '#unisex' },
  { label: 'Bundles', href: '#bundles' },
  { label: 'Sample Kit', href: '#sample' },
  { label: 'Our Story', href: '#story' }
];

export const products = [
  {
    id: 'rp-royal-white',
    code: 'RP-0001',
    name: 'Royal White',
    slug: 'royal-white',
    shots: ['/products/royal-white.webp', '/products/royal-white-2.webp'],
    tagline: 'Citrus, spicy, woody',
    type: 'EXTRAIT DE PARFUM',
    gender: 'MEN',
    family: 'WOODY SPICY',
    price: 799,
    mrp: 1999,
    rating: 4.8,
    reviews: 36,
    badge: 'HOUSE SIGNATURE',
    accent: '#E08A3C',
    tags: ['Office', 'Everyday', 'Date Night'],
    description:
      'A wide-open coastline at golden hour. Bright citrus lifts into warm spice before settling on clean, sunlit woods — composed, confident, and easy to wear from morning to midnight.',
    notes: {
      top: ['Bergamot', 'Lemon'],
      middle: ['Nutmeg', 'Pink Pepper'],
      base: ['Cedar', 'Vetiver']
    }
  },
  {
    id: 'rf-rose-and-oud',
    code: 'RF-0002',
    name: 'Rose & Oud',
    slug: 'rose-and-oud',
    shots: ['/products/rose-and-oud.webp'],
    tagline: 'Rose, oud, sweet, floral',
    type: 'EXTRAIT DE PARFUM',
    gender: 'UNISEX',
    family: 'FLORAL OUD',
    price: 899,
    mrp: 1999,
    rating: 4.9,
    reviews: 47,
    badge: 'MOST LOVED',
    accent: '#C4657F',
    tags: ['Date Night', 'Party', 'Everyday'],
    description:
      'A rose garden running down to the sea at sunset. Petals open sweet and dewy, then deepen into resinous oud — the house at its most romantic and its most serious, at once.',
    notes: {
      top: ['Saffron', 'Litchi'],
      middle: ['Damask Rose', 'Jasmine'],
      base: ['Oud', 'Amber']
    }
  },
  {
    id: 'rp-ombre-nomade',
    code: 'RP-0005',
    name: 'Ombre Nom@de',
    slug: 'ombre-nomade',
    shots: ['/products/ombre-nomade.webp', '/products/ombre-nomade-2.webp'],
    tagline: 'Amber, oud, warm spicy, rose',
    type: 'EXTRAIT DE PARFUM',
    gender: 'UNISEX',
    family: 'AMBERY',
    price: 899,
    mrp: 1999,
    rating: 4.9,
    reviews: 43,
    badge: 'TRENDING NOW',
    accent: '#7B4B7F',
    tags: ['Date Night', 'Party'],
    description:
      "A wanderer's signature. Warm amber and deep oud lifted by rose and a trail of spice — built for long evenings a long way from home.",
    notes: {
      top: ['Cardamom', 'Warm Spice'],
      middle: ['Rose', 'Oud'],
      base: ['Amber', 'Musk']
    }
  },
  {
    id: 'bp-bombshell',
    code: 'RP-0008',
    name: 'Bombshell',
    slug: 'bombshell',
    shots: ['/products/bombshell.webp', '/products/bombshell-2.webp'],
    tagline: 'Fruity, sweet, fresh, citrus',
    type: 'EXTRAIT DE PARFUM',
    gender: 'WOMEN',
    family: 'FRUITY FLORAL',
    price: 799,
    mrp: 1999,
    rating: 4.9,
    reviews: 52,
    badge: "EDITOR'S PICK",
    accent: '#7E4FA8',
    tags: ['Party', 'Everyday', 'Date Night'],
    description:
      'Loud in the best way. Juicy fruit and bright citrus over a soft floral heart, finishing sweet and radiant — the one people stop you to ask about.',
    notes: {
      top: ['Grapefruit', 'Mandarin'],
      middle: ['Peony', 'Passionfruit'],
      base: ['Vanilla', 'White Musk']
    }
  },
  {
    id: 'bp-cool-water-women',
    code: 'BP-0005-W',
    name: 'Cool Water Women',
    slug: 'cool-water-women',
    shots: ['/products/cool-water-women.webp', '/products/cool-water-women-2.webp'],
    tagline: 'Fresh, feminine, sensual',
    type: 'EXTRAIT DE PARFUM',
    gender: 'WOMEN',
    family: 'FRESH FLORAL',
    price: 799,
    mrp: 1999,
    rating: 4.8,
    reviews: 31,
    badge: 'NEW ARRIVAL',
    accent: '#2E7A9E',
    tags: ['Everyday', 'Office', 'Date Night'],
    description:
      'Arms open on a sunlit pier. Cool sea air and soft petals wrapped in skin-warm musk — fresh at first breath, quietly sensual by the end of the day.',
    notes: {
      top: ['Sea Breeze', 'Pineapple'],
      middle: ['Water Lily', 'Jasmine'],
      base: ['White Musk', 'Sandalwood']
    }
  },
  {
    id: 'rp-aventus',
    code: 'RP-0007',
    name: 'Aventus',
    slug: 'aventus',
    shots: ['/products/aventus.webp', '/products/aventus-2.webp'],
    tagline: 'Fruity, citrus, woody, powdery',
    type: 'EXTRAIT DE PARFUM',
    gender: 'MEN',
    family: 'FRUITY CHYPRE',
    price: 899,
    mrp: 1999,
    rating: 4.9,
    reviews: 61,
    badge: 'BEST SELLER',
    accent: '#C0392B',
    tags: ['Office', 'Date Night', 'Party'],
    description:
      'The boardroom favourite. Smoky pineapple and crisp citrus over birch and moss — powdery, polished and unmistakably expensive on the skin.',
    notes: {
      top: ['Pineapple', 'Bergamot'],
      middle: ['Birch', 'Patchouli'],
      base: ['Oakmoss', 'Musk']
    }
  },
  {
    id: 'ep-savage-edge',
    code: 'EP-0009',
    name: 'Savage Edge',
    slug: 'savage-edge',
    shots: ['/products/savage-edge.webp', '/products/savage-edge-2.webp'],
    tagline: 'Citrus, aromatic, marine',
    type: 'EXTRAIT DE PARFUM',
    gender: 'MEN',
    family: 'AROMATIC MARINE',
    price: 799,
    mrp: 1999,
    rating: 4.7,
    reviews: 28,
    badge: 'HOT SELLING',
    accent: '#D2812F',
    tags: ['Everyday', 'Party', 'Office'],
    description:
      'Salt air off a surf shack at last light. Sharp citrus and aromatic herbs over a clean marine base — rugged, easy, and impossible to overdo.',
    notes: {
      top: ['Bergamot', 'Sea Salt'],
      middle: ['Lavender', 'Geranium'],
      base: ['Ambroxan', 'Cedar']
    }
  },
  {
    id: 'ep-dark-secret',
    code: 'EP-0001',
    name: 'Dark Secret',
    slug: 'dark-secret',
    shots: ['/products/dark-secret.webp', '/products/dark-secret-2.webp'],
    tagline: 'Citrus, fruity, powdery',
    type: 'EXTRAIT DE PARFUM',
    gender: 'UNISEX',
    family: 'CITRUS GOURMAND',
    price: 799,
    mrp: 1999,
    rating: 4.9,
    reviews: 44,
    badge: 'COLLECTION HIGHLIGHT',
    accent: '#B5462A',
    tags: ['Date Night', 'Party'],
    description:
      'A lone rider against a burning horizon. Bright citrus and dark fruit dusted with powder and tonka — addictive, a little secretive, and it lasts all night.',
    notes: {
      top: ['Bergamot', 'Pink Pepper'],
      middle: ['Cherry', 'Iris'],
      base: ['Tonka', 'Sandalwood']
    }
  },
  {
    id: 'rp-cool-water',
    code: 'RP-030-1',
    name: 'Cool Water',
    slug: 'cool-water',
    shots: ['/products/cool-water.webp', '/products/cool-water-2.webp'],
    tagline: 'Fresh, marine, aromatic, musky',
    type: 'EXTRAIT DE PARFUM',
    gender: 'MEN',
    family: 'AQUATIC',
    price: 899,
    mrp: 1999,
    rating: 4.8,
    reviews: 39,
    badge: 'TOP PICK',
    accent: '#35618A',
    tags: ['Office', 'Everyday'],
    description:
      'Two friends, one horizon. Cool mint and lavender over open sea notes, drying down to clean musk and cedar — the most effortless bottle in the house.',
    notes: {
      top: ['Mint', 'Lavender'],
      middle: ['Sea Notes', 'Coriander'],
      base: ['White Musk', 'Cedar']
    }
  }
];

export const categories = [
  {
    id: 'award',
    title: 'Award Winners',
    subtitle: 'Rated 4.8 and above',
    image: nobgBottleImg('aventus'),
    accent: '#C0392B',
    href: '#most-loved'
  },
  {
    id: 'him',
    title: 'For Him',
    subtitle: 'Woody, marine, aromatic',
    image: nobgBottleImg('cool-water'),
    accent: '#35618A',
    href: '#him'
  },
  {
    id: 'her',
    title: 'For Her',
    subtitle: 'Floral, fruity, radiant',
    image: nobgBottleImg('bombshell'),
    accent: '#7E4FA8',
    href: '#her'
  },
  {
    id: 'magnet',
    title: 'Compliment Magnets',
    subtitle: 'The head-turners',
    image: nobgBottleImg('ombre-nomade'),
    accent: '#7B4B7F',
    href: '#bundles'
  }
];

/** Featured hero slides — fixed order so the LCP image can be preloaded. */
export function pickHeroSlides(count = 4) {
  const featured = HERO_FEATURED_SLUGS
    .map((slug) => products.find((p) => p.slug === slug))
    .filter(Boolean);
  return featured.slice(0, count).map((p) => ({
    productId: p.id,
    title: p.name,
    subtitle: p.tagline,
    accent: p.accent,
    bottle: nobgBottleImg(p.slug),
  }));
}

/** Initial slides (re-picked on each full page load via HeroBanners). */
export const heroSlides = pickHeroSlides(4);

export const reviews = [
  { name: 'Vikram Desai', date: '19 Jul, 2026', rating: 5, text: 'Iski vibe ekdum late-night city drive wali hai. The fresh citrus opening blends so well with the spicy warm base. Long lasting, easily 8+ hours.' },
  { name: 'Aman Verma', date: '17 Jul, 2026', rating: 5, text: 'Fresh and spicy night vibe. Bilkul mast!' },
  { name: 'Rahul Mehta', date: '13 Jul, 2026', rating: 5, text: 'Bohot modern khushboo hai. Office ke liye perfect.' },
  { name: 'Karthik Nair', date: '09 Jul, 2026', rating: 5, text: 'Perfect for city nights. Projection is amazing.' },
  { name: 'Rohan Singh', date: '07 Jul, 2026', rating: 4, text: 'Energetic and classy. Value for money.' },
  { name: 'Devansh Gupta', date: '03 Jul, 2026', rating: 5, text: 'Ekdum luxury feel aati hai. Packaging bhi solid.' },
  { name: 'Karan Malhotra', date: '27 Jun, 2026', rating: 5, text: 'Sophisticated spice. Compliment magnet for sure.' },
  { name: 'Nitin Shah', date: '24 Jun, 2026', rating: 5, text: 'Bhai kya mast projection hai! Sabne pucha kaunsa hai.' },
  { name: 'Rohan Patel', date: '20 Jul, 2026', rating: 5, text: 'Party me lagake gaya tha, 3 logo ne poocha kaunsa lagaya hai! Blend kamaal ki hai.' },
  { name: 'Saurabh Mishra', date: '19 Jul, 2026', rating: 5, text: 'Sweet, fresh, and very magnetic. Loved it.' },
  { name: 'Kavya Jain', date: '17 Jul, 2026', rating: 5, text: 'Gifted to boyfriend, he smells amazing. Highly recommend!' },
  { name: 'Neha Kapoor', date: '12 Jul, 2026', rating: 5, text: 'Absolutely gorgeous scent. My new signature.' }
];

export const instagramPosts = [
  '/branded/ig-1.webp',
  '/branded/ig-2.webp',
  '/branded/ig-3.webp',
  '/branded/ig-4.webp',
  '/branded/ig-5.webp',
  '/branded/ig-6.webp'
];

export const founderImage = '/branded/banner-founder.webp';
export const sampleKitImage = '/branded/banner-sample.webp';
export const specialOfferImage = '/branded/banner-offer.webp';
export const collectionBannerImage = '/branded/banner-collection.webp';
